import React, { useEffect, useState } from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Contactform from '../Mencontact/Contactform'

import Footer from '../Footer/Main'
import AddJobForm from '../AddJobForm/Main'
import { getStrapiData } from '../../api.controller'

function Main() {

  const [data, setData] = useState();
  useEffect(() => {
    getStrapiData("add-job-page").then(response => {
      console.log(response);
      setData(response.data);
    });
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <Header />
        <Breadcrumb data={data} subtitle="Home" title="Add Job" />
        <AddJobForm />

        <Footer />
      </div>
    </div>
  )
}

export default Main